
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { createSelector } from 'reselect';
import * as yup from 'yup';

import { didPropChange } from 'utils/props';

import Account from 'store/models/Account';
import Channel, { selectChannelsByAccount } from 'store/models/Channel';
import { selectCurrentAccountId } from 'store/AppState';
import UIState from 'store/UIState';


import Modal, { ModalContent, ModalHeader, ModalTitle, ModalSubtitle, ModalActions } from 'components/Modal';
import { ErrorList } from 'components/forms/Error';
import Button from 'components/Button';
import ItemPicker, { ChannelItem } from 'components/ItemPicker';
import ChannelCard from 'components/ChannelCard';
import Scrollbars from 'react-custom-scrollbars';




// ======================
// STORE
// ====================== 
const actions = {
  closeModal: UIState.actions.closeModal,
  showModal: UIState.actions.showModal,
  
}

const selector = createSelector(
  state => selectChannelsByAccount(state, selectCurrentAccountId(state)),
  (channels) => Object.assign({
    channels
  })
);

const withConnect = connect(selector, actions);


// ======================
// COMPONENT
// ====================== 
class ChannelPickerModal extends React.Component {
  state = {
    selected: [],
  }

  componentDidMount() {
    if(this.props.selectedIds)
      this.setState({ selected: this.props.selectedIds })
    if(this.props.channels)
      this.initChannels(this.props.channels)
  }

  componentDidUpdate(prev) {
    if(didPropChange(this.props, prev, 'channels'))
      this.initChannels(this.props.channels)
    if(didPropChange(this.props, prev, 'selectedIds'))
      this.setState({ selected: this.props.selectedIds })
  }

  initChannels = channels => this.setState({ notSelected: channels })

  onAddChannel = channelId => this.setState({
    selected: [...this.state.selected, channelId] |> _.uniq,
  })

  onRemoveChannel = channelId => this.setState({ 
    selected: _.without(this.state.selected, channelId) 
  })

  onSave = () => {
    this.props.onSave?.(this.state.selected)
    this.props.closeModal();
  }

  render() {
    let { channels, title, subtitle } = this.props;
    let { selected, notSelected, saving } = this.state;
    title = title ?? 'Target A Channel For A Campaign';
    subtitle = subtitle ?? 'Target specific channels for this campaign';
    channels = _.orderBy(channels, 'displayName', 'asc');
    return (
      <Modal className="modal channel-picker fill-vert s">
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ModalSubtitle>{subtitle}</ModalSubtitle>
        </ModalHeader>
        <ModalContent>
          <ItemPicker 
            selectedItems={selected} 
            onSelectItem={this.onAddChannel}
            onRemoveItem={this.onRemoveChannel}>
            {_.map(channels, channel => <ChannelItem key={channel?._id} itemId={channel?._id} channel={channel} />)}
          </ItemPicker>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={this.onSave}
            disabled={saving}>Save</Button>
        </ModalActions>
      </Modal>);
  }
};

export default ChannelPickerModal
  |> withConnect
